import { get, writable } from "svelte/store";

const STORAGE_KEY = "shelly_dev_event_log_sticky_toolbar";

const readInitialValue = (): boolean => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		// Default off: the filter toolbar flows with the table until the sticky
		// hide/reveal behaviour is validated on mobile.
		if (stored === null) return false;
		return stored === "true";
	} catch {
		return false;
	}
};

/**
 * When true, the Activity Log filter toolbar sticks to the top of the scroll
 * container and hides on downward scroll / reveals on upward scroll. When
 * false it scrolls away with the table. Preference is saved locally.
 */
export const eventLogStickyToolbarEnabled =
	writable<boolean>(readInitialValue());

eventLogStickyToolbarEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isEventLogStickyToolbarEnabled = (): boolean =>
	get(eventLogStickyToolbarEnabled);

export const setEventLogStickyToolbarEnabled = (enabled: boolean) => {
	eventLogStickyToolbarEnabled.set(enabled);
};
